module.exports = __webpack_public_path__ + "static/media/bg2.7e89a5a0.png";